import { __assign } from 'tslib';
export var assign = __assign;
//# sourceMappingURL=utilities.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@uifabric/foundation/lib/utilities.js
// module id = 406
// module chunks = 0